var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "primary-color-picker" }, [
    _c(
      "div",
      { staticClass: "palette" },
      _vm._l(_vm.palette, function (color) {
        return _c("button", {
          key: color,
          staticClass: "palette-swatch",
          class: { "is-active": _vm.isSwatchActive(color) },
          style: { backgroundColor: color },
          attrs: { type: "button", "aria-label": color },
          on: {
            click: function ($event) {
              return _vm.onPickColor(color)
            },
          },
        })
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "custom-hex" },
      [
        _c("label", { staticClass: "custom-hex-label" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.settings.branding.primaryColor.customHex")) +
              " "
          ),
        ]),
        _c("el-input", {
          staticClass: "custom-hex-input",
          attrs: { maxlength: "7", placeholder: "#0060EE" },
          on: {
            blur: _vm.onHexInputCommit,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onHexInputCommit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.hexInput,
            callback: function ($$v) {
              _vm.hexInput = $$v
            },
            expression: "hexInput",
          },
        }),
        _vm.hexError
          ? _c("p", { staticClass: "custom-hex-error" }, [
              _vm._v(" " + _vm._s(_vm.hexError) + " "),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "reset-row" },
      [
        _c(
          "el-link",
          {
            attrs: { type: "primary", underline: false },
            on: { click: _vm.onReset },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("pages.settings.branding.primaryColor.resetToDefault")
                ) +
                " "
            ),
          ]
        ),
      ],
      1
    ),
    _vm.hasUnsavedPreview
      ? _c(
          "footer",
          { staticClass: "action-bar" },
          [
            _c(
              "ib-button",
              { attrs: { loading: _vm.saving }, on: { click: _vm.onSave } },
              [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
            ),
            _c(
              "ib-button",
              {
                attrs: { disabled: _vm.saving, plain: "", variant: "white" },
                on: { click: _vm.onCancel },
              },
              [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }